import { Flex } from 'antd';

export const Legends = () => {
  return (
    <Flex gap={'small'} align="center">
      <div
        style={{
          backgroundColor: '#E09101',
          width: '1rem',
          height: '1rem',
        }}
      ></div>
      <span>Overtime</span>
    </Flex>
  );
};
